import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import TxRow from 'src/features/transactions/TxRow';

function TransactionListDesktop({ transactions, redirect }) {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 4,
        border: `1px solid ${theme.palette.divider}`,
        overflow: 'hidden',
        bgcolor: 'background.paper',
      }}
    >
      <Box
        sx={{
          px: 2.5,
          py: 3,
          borderBottom: `1px solid ${theme.palette.divider}`,
          background: `linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.04)} 0%, transparent 100%)`,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 800, letterSpacing: '-0.02em' }}>
          Recent transactions
        </Typography>
      </Box>

      <TableContainer sx={{ overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow
              sx={{
                bgcolor: alpha(
                  theme.palette.text.primary,
                  theme.palette.mode === 'dark' ? 0.04 : 0.025
                ),
              }}
            >
              <TableCell align="center" sx={headCellSx}>
                Status
              </TableCell>
              <TableCell align="center" sx={headCellSx}>
                Transaction
              </TableCell>
              <TableCell align="center" sx={headCellSx}>
                Date
              </TableCell>
              <TableCell align="center" sx={headCellSx}>
                Action
              </TableCell>
              <TableCell align="center" sx={headCellSx}>
                View
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {transactions.map((tx) => (
              <TxRow onClick={() => redirect?.(tx)} redirect={redirect} key={tx._id} tx={tx} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

const headCellSx = {
  py: 1.5,
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: 0.6,
  textTransform: 'uppercase',
  color: 'text.secondary',
  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
};

TransactionListDesktop.propTypes = {
  redirect: PropTypes.func,
  transactions: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      amountIn: PropTypes.string.isRequired,
      amountOut: PropTypes.string,
      tokenIn: PropTypes.string,
      tokenOut: PropTypes.string,
      createdAt: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      from: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
      txHashOut: PropTypes.string,
    })
  ).isRequired,
};

export default TransactionListDesktop;
